// Cart drawer suggestions. Clicking [data-upsell-add] adds one of that variant to the cart through
// Shopify.actions.updateCart (the same path as the product form). The updateCart override refreshes
// the drawer partials, so the added product moves into the cart list and drops out of the suggestions.
class CartUpsell extends HTMLElement {
  #controller = null;

  connectedCallback() {
    this.#controller = new AbortController();
    this.addEventListener('click', (event) => this.#onClick(event), { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  async #onClick(event) {
    const button = event.target.closest('[data-upsell-add]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    const variantId = button.dataset.variantId;
    if (!variantId || !window.Shopify?.actions?.updateCart) return;

    button.setAttribute('aria-busy', 'true');
    try {
      const result = await window.Shopify.actions.updateCart(
        { lines: [{ merchandiseId: variantId, quantity: 1 }] },
        { event: { context: 'cart' } }
      );
      const message = result?.userErrors?.[0]?.message;
      if (message) button.title = message;
    } catch {
      /* Leave the button usable if the request fails. */
    } finally {
      if (button.isConnected) button.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('s-cart-upsell')) customElements.define('s-cart-upsell', CartUpsell);
